import React, { useContext, useEffect, useRef, useState } from 'react';
import { Dropdown } from 'react-bootstrap';
import _ from 'lodash';

import AppContext from '../../../context';
import { LockIcon } from '../../../../assets/misc/index';
import { ReactComponent as AngleDown } from '../../../../assets/icons/angle-down.svg';
import UpgradeModal from '../../../common/upgrade_modal/upgrade_modal.component';
import './radio_group.component.css';

const RadioGroup = (props) => {
  const context = useContext(AppContext);
  const [showUpgradeModal, setShowUpgradeModal] = useState(false);
  //mobile
  const [isMobile, setIsMobile] = useState(false);
  const [showSlideModal, setShowSlideModal] = useState(false);
  const slideModalRef = useRef(null);

  let portfolios = context.portfolios;
  if (props.ignoreFamily) {
    portfolios = portfolios.slice(1);
  }

  const isDisabled = (pf) => {
    //for both free & paid plan
    let res = false;
    if (pf.is_dummy || pf.is_empty) res = true;
    let pfs = context.portfolios.filter((pf) => !pf.is_dummy && !pf.is_empty);
    if (pfs.length - 1 === 1 && pf.id === 'family') {
      //disable family if single pf
      res = true;
    }
    return res;
  };

  const isLocked = (pf) => {
    //for free plan
    let res = false;
    if (
      context.planDetails.name === 'free' &&
      (pf.id === 'family' || pf.is_dummy)
    ) {
      res = true;
    }
    return res;
  };

  useEffect(() => {
    if (!slideModalRef.current) return;
    if (showSlideModal) {
      setTimeout(() => {
        slideModalRef.current
          .querySelector('.radio_modal')
          .classList.add('open');
      }, []);
    }
  }, [showSlideModal]);

  useEffect(() => {
    if (isMobile && showSlideModal) {
      slideModalRef.current
        .querySelector('.radio_modal')
        .classList.remove('open');
      setTimeout(() => {
        setShowSlideModal(false);
      }, [300]);
    }
  }, [props.checked]);

  useEffect(() => {
    if (window.innerWidth <= 1100) {
      setIsMobile(true);
    }
    const handleResize = _.debounce(() => {
      if (window.innerWidth <= 1100 && !isMobile) {
        setIsMobile(true);
      } else {
        setIsMobile(false);
      }
    }, 100);
    window.addEventListener('resize', handleResize);
  }, []);

  return (
    <>
      <Dropdown className="pf_dropdown">
        <Dropdown.Toggle>
          <span className="pf_name">
            {context.portfoliosById[props.checked].name}
          </span>
          <span>
            <AngleDown />
          </span>
        </Dropdown.Toggle>
        <Dropdown.Menu>
          {portfolios.map((option) => {
            return (
              <Dropdown.Item
                key={option.id}
                disabled={isDisabled(option) || isLocked(option)}
                onClick={() => {
                  if (isLocked(option)) {
                    setShowUpgradeModal(true);
                    return;
                  }
                  props.setChecked(option.id);
                }}
              >
                {option.name}
              </Dropdown.Item>
            );
          })}
        </Dropdown.Menu>
      </Dropdown>
      {context.planDetails.name === 'free' ? (
        <UpgradeModal
          isVisible={showUpgradeModal}
          setIsVisible={(v) => setShowUpgradeModal(v)}
        />
      ) : null}
    </>
  );
};

export default RadioGroup;
